import React from 'react';
import { MenuSelector } from 'components/shared';
import { Box } from 'components/ui/Box';
import {
  InnerNavigator,
  InnerNavigatorOption,
} from 'components/ui/InnerNavigator';
import { useTranslation } from 'hooks';
import { translations } from './translations';
import { Settings } from 'lucide-react';

type LayoutProps = {
  children: React.ReactNode;
  page: string;
  options?: InnerNavigatorOption[];
};

export const SettingLayout: React.FC<LayoutProps> = ({
  children,
  options,
  page,
}) => {
  const { getTranslation } = useTranslation(translations);
  return (
    <section className="p-4">
      <Box className="py-2 mb-4">
        <div className="flex items-center w-max text-slate-6s00">
          <h1 className="flex items-center gap-2">
            <Settings />
            {getTranslation('configuracoes')}
          </h1>
          <MenuSelector page={page} />
        </div>
      </Box>
      {options && <InnerNavigator options={options} />}
      <section className="py-6">{children}</section>
    </section>
  );
};
